import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/pngs/illus-home.png'


const _hoisted_1 = { class: "space-y-3 pt-8 w-auto rounded h-screen flex items-center bg-gray-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container grid justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-16 w-24"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-3xl pt-5 text-black font-semibold" }, "No results found")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}